<template>
  <div>
    <Row>
      <Col span="7">{{ field }}</Col>
      <Col span="6" class="pre ratio">{{ preRatio }}</Col>
      <Col span="5" class="ratio" :style="diffStyle">{{ diffRatio }}</Col>
      <Col span="6" class="ratio">{{ currentRatio }}</Col>
    </Row>
  </div>
</template>

<script>
export default {
  props: ["field", "value", "detail"],
  name: "RecipeRow",
  data() {
    return {};
  },
  computed: {
    currentRatio: function () {
      if (this.value.allDetail) {
        const currentDetail = this.value.detail;
        let ratio = null;
        const data = currentDetail.filter((x) => {
          return x.material._id === this.detail.material._id;
        });
        if (data.length > 0) {
          ratio = (data[0].ratio * 100).toFixed(3) + "%";
        } else {
          ratio = undefined;
        }
        return ratio ? ratio : "-";
      } else {
        return this.detail.ratio
          ? (this.detail.ratio * 100).toFixed(3) + "%"
          : "-";
      }
    },
    preRatio: function () {
      if (this.value.allDetail) {
        const currentDetail = this.value.prevRecipeSales.detail;
        const data = currentDetail.filter((x) => {
          return x.material._id === this.detail.material._id;
        });
        let ratio = null;
        if (data.length > 0) {
          ratio = (data[0].ratio * 100).toFixed(3) + "%";
        } else {
          ratio = undefined;
        }

        return ratio ? ratio : "-";
      } else {
        if (this.value.prevRecipeSales) {
          return (this.value.prevRecipeSales.ratio * 100).toFixed(3) + "%";
        } else {
          return "-";
        }
      }
    },
    diffRatio: function () {
      if (this.value.prevRecipeSales) {
        let cur = this.currentRatio.substring(0, this.currentRatio.length - 1);
        let pre = this.preRatio.substring(0, this.preRatio.length - 1);
        const diff = (cur - pre).toFixed(3);
        if (diff == 0) {
          return "-";
        }
        return diff + "%";
      } else {
        return "-";
      }
    },
    diffStyle: function () {
      let diffRatio = this.diffRatio.substring(0, this.diffRatio.length - 1);
      const style = { color: "black" };
      if (diffRatio > 0) {
        style.color = "rgba(150,0,0,0.7)";
      } else if (diffRatio < 0) {
        style.color = "rgba(0,150,0,0.7)";
      } else {
        style.color = "lightgray";
      }
      return style;
    },
    colSpan: function () {
      if (this.value.prevRecipeSales) {
        return 6;
      } else {
        return 6;
      }
    },
  },
  methods: {},
};
</script>
<style lang="stylus" scoped>
.pre
  color darkgray

.ratio
  text-align right
</style>